import React from 'react';
import {IndexLink, Link} from 'react-router';
import {connect} from 'react-redux';
import * as commonApi from '../../../api/common-api';
import Loading from 'react-loading';
import Feed from './Feed';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import {Player, BigPlayButton} from 'video-react';
import TrackVisibility from 'react-on-screen';

var querystring = require('querystring');


var courseId = 0;

class CoursePostsFeeds extends React.Component {
    constructor(props) {
        super(props);

        this.state = {feedArr: []};
        courseId = this.props.courseId;
        this.generateFeed = this.generateFeed.bind(this);
    }


    componentDidMount() {
        this.generateFeed(this.props);

    }

    generateFeed(props) {

        var feedArr = [];
        var idx = 0;
        for (var feeditem of props.feeds) {
            var detail = 0;
            if (this.props.detail != undefined) {
                detail = this.props.detail;
            }
            feedArr.push(
                <TrackVisibility>
                <Feed
                    socket={this.props.socket}
                    detail={detail}
                    course={this.props.course}
                    user={this.props.user}
                    handleFeedCallback={this.props.handleFeedCallback}
                    key={idx + "feed-b-" + feeditem.feed_type + feeditem.id_feed}
                    courseId={courseId}
                    feed={feeditem}
                    isMobile={this.props.isMobile}
                />
                </TrackVisibility>
            )
            idx++;
        }
        this.setState({feedArr: feedArr});
        //store.dispatch(getUserSuccess(response.data.data));
    }

    componentWillReceiveProps(nextProps) {
        //courseId = nextProps.courseId;
        this.generateFeed(nextProps);
    }

    render() {
        return (<div>
            {this.state.feedArr}
        </div>);
    }
}

export default CoursePostsFeeds;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/course/course_posts_feeds.js
 **/